export default "__VITE_ASSET__CswFj3GG__"